import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NGXLogger } from 'ngx-logger';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import { StockAction } from './stock.actions';
import { StockService } from '../service/stock.service';

@Injectable()
export class StockEffects {
  constructor(
    private actions$: Actions,
    private logger: NGXLogger,
    private stockService: StockService
  ) {}

  stockListRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StockAction.stockListRequest),
      tap((_) => this.logger.debug('@Effect [Stock] Stock list request ')),
      switchMap(({ payload }) => {
        return this.stockService.getList({ ...payload }).pipe(
          map((response) => {
            return StockAction.stockListResponse({ response });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });

  stockNativeArticleCountRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StockAction.stockListNativeCountRequest),
      tap((_) => this.logger.debug('@Effect [Stock] Stock list native count request')),
      switchMap(() => {
        return this.stockService.getStockListNativeCount().pipe(
          map((response) => {
            return StockAction.stockListNativeCountResponse({ response });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });

  stockSummaryRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StockAction.stockSummaryRequest),
      tap((_) => this.logger.debug('@Effect [Stock] Stock summary request ')),
      switchMap(({ articleNo }) => {
        return this.stockService.getStockSummary(articleNo).pipe(
          map((response) => {
            return StockAction.stockSummaryResponse({ response });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });

  stockMovementBarcodeRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StockAction.stockBarcodeListRequest),
      tap((_) => this.logger.debug('@Effect [Stock] Stock barcode request')),
      switchMap(({ articleNo }) => {
        return this.stockService.getStockBarcode(articleNo).pipe(
          map((response) => {
            return StockAction.stockBarcodeListResponse({ response });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });

  stockMovementListRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StockAction.stockMovementListRequest),
      tap((_) => this.logger.debug('@Effect [Stock] Stock list request ')),
      switchMap(({ payload }) => {
        return this.stockService.getMovementList({ ...payload }).pipe(
          map((response) => {
            return StockAction.stockMovementListResponse({ response });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });

  adjustTransactionRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(StockAction.adjustTransactionRequest),
      tap((_) => this.logger.debug('@Effect [Stock] Adjust Transaction Request')),
      switchMap(({ articleNo }) => {
        return this.stockService.adjustTransaction(articleNo).pipe(
          map((response) => {
            return StockAction.adjustTransactionResponse({ response });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });
}
